import { LAYOUT_COMPONENTS } from './layouts';

export const COMPONENTS = [...LAYOUT_COMPONENTS];
